<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getExpense,
  add,
  del,
  update,
  getDetails
} from "@/api/finance/expense";
import { getCurrency } from "@/api/finance/currency";
import cTable from "@/base/common/index";
export default {
  name: "incomeSubject",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getExpense,
        getDetails,
        add,
        update,
        del,
        getCurrency
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              let type = "add";
              if (row.id) {
                type = "update";
                data.id = row.id;
              }
              this.$page.handleRequestMethods(type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              name_en: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur"
                }
              ],
              // remarks: [
              //   {
              //     required: true,
              //     message: "remarks cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              sort: [
                {
                  required: true,
                  type: "number",
                  message: "sort cannot be empty",
                  trigger: "blur"
                }
              ],
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { name: 24 },
            { name_en: 24 },
            { code: 24 },
            { sort: 24 },
            { status: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("expenseName"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("expenseName")
            },
            {
              name: () => this.$t("expenseName") + this.$t("En"),
              key: "name_en",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("expenseName") + this.$t("En")
            },
            {
              name: () => this.$t("expenseCode"),
              key: "code",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("expenseCode")
            },

            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                step: 1,
                min: 0,
                style: {
                  width: "100%"
                }
              },
              default: 0
            },
            {
              name: () => this.$t("status"),
              key: "status",
              component: "Radio",
              bind: {
                border: true
              },
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" }
              ]
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 140
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("expenseName"),
          key: "name",
          align: "left",
          minWidth: 100
        },
				{
				  name: () => this.$t("expenseNameEn"),
				  key: "name_en",
				  align: "left",
				  minWidth: 100
				},
        {
          name: () => this.$t("expenseCode"),
          key: "code",
          minWidth: 150,
          align: "left"
        },
        {
          name: () => this.$t("status"),
          key: "status",
          minWidth: 110
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          minWidth: 100
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 160
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          minWidth: 160
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 80,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 141
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete"
            // }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").open(res.payload);
              });
            }
            // delete({ row }) {
            //   this.$Modal.confirm({
            //     title: this.$t("delete"),
            //     width: 300,
            //     content: this.$t("titleModal"),
            //     onOk: () => {
            //       this.handleRequestMethods("del", row.id).then(res => {
            //         this.$Message["success"]({
            //           background: true,
            //           content: res.msg
            //         });
            //         this.getList();
            //       });
            //     }
            //   });
            // }
          }
        }
      ]
    };
  }
};
</script>
